import WhyUseLumiPage from "@components/why-use-lumi-page/why-use-lumi";
import { ssrWhyUseLumi, PageWhyUseLumiComp } from "@graphql/generated/page";
import { loadTranslation } from "@lib/utils";
import { GetStaticProps } from "next";
import { t } from "@lingui/macro";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const translation = await loadTranslation(
    locale,
    process.env.NODE_ENV == "production"
  );

  const {
    props: { data },
  } = await ssrWhyUseLumi.getServerPage({});

  return { props: { data, translation, locale } };
};

const WhyUseLumi: PageWhyUseLumiComp = ({ data }) => {
  const router = useRouter();
  const locale = router.locale || router.defaultLocale;
  const seoLocale = "/" + locale;
  const title = t`Why Use Lumi - Lumi News Malaysia`;
  const description = t`Lumi News is Malaysia’s latest news app featuring breaking news and headlines reported by over 50 quality publishers.`;
  return (
    <>
      <NextSeo
        title={title}
        description={description}
        openGraph={{
          url: `https://luminews.my${
            seoLocale.includes("en") ? "" : seoLocale
          }${router.asPath}`,
          title: title,
          description: description,
        }}
      />
      <WhyUseLumiPage data={data} locale={locale} />
    </>
  );
};

export default WhyUseLumi;
